import React, { FC, useMemo } from 'react';

import { Typography } from '../../../typography';
import Select from '../../../select';

interface IInputProps {
	title: string;
	value: string;
	callback(type: string): void;
}

const ChartType: FC<IInputProps> = ({ title, value, callback }) => {
	const options = useMemo(
		() => [
			{
				title: 'Bar',
				type: 'column',
			},
			{
				title: 'Line',
				type: 'line',
			},
			{
				title: 'Pie',
				type: 'pie',
			},
			{
				title: 'Table',
				type: 'table',
			},
		],
		[]
	);

	const newValue = options.find((option: any) => option.type === value);

	return (
		<div style={{width: '100%'}}>
			<div>
				<Typography type="bold" size="medium" text={title} />
			</div>
			<div>
				<Select
					isFullWidth
					options={options}
					callback={(option: any) => callback(option.type)}
					value={newValue?.title || 'Summary'}
				/>
			</div>
		</div>
	);
};

export default ChartType;
